import { IStandard } from "src/domain/entities"
import { standardListApi } from "../../api/standard/standardListApi"

type PayloadShape = Parameters<typeof standardListApi>[0]

export async function standardListService(payload: PayloadShape, token?: null | string) {
	const standard = await standardListApi(payload, token)
	return standard as NonNullable<IStandard[]>
}
